import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IOrderSummary_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IOrderSummary_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class OrderSummary_ScreenBase extends React.PureComponent<
  IOrderSummary_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  ordersummary_987972_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9d90b1f3-f952-454b-b753-1f6abdc7905c",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 864519, PropertyName: "label", Value: "Ödeme Planı" },
        { Id: 374235, PropertyName: "label", Value: "Siparişi Gönder" },
        { Id: 185241, PropertyName: "value", Value: "Ana Sayfa" },
        { Id: 831255, PropertyName: "value", Value: "Müşteri Seç" },
        { Id: 236745, PropertyName: "value", Value: "Ürün Bul" },
        { Id: 309046, PropertyName: "value", Value: "Sepet" },
        { Id: 279449, PropertyName: "value", Value: "Menü" },
        { Id: 897348, PropertyName: "value", Value: "Sepet" },
        {
          Id: 665149,
          PropertyName: "value",
          Value:
            "Ürünleri gözden geçirin, adedi güncelleyin ve siparişi tamamlayın.",
        },
        { Id: 214323, PropertyName: "title", Value: "Title" },
        {
          Id: 231954,
          PropertyName: "value",
          Value: "AYRILDIZ MIA GOLD 24 PARÇA YEMEK TAKIMI",
        },
        { Id: 88901, PropertyName: "value", Value: "#153AR998354" },
        { Id: 767862, PropertyName: "value", Value: "Birim Fiyat" },
        { Id: 976439, PropertyName: "value", Value: "₺2.399,90" },
        { Id: 879085, PropertyName: "value", Value: "Ödeme" },
        { Id: 318347, PropertyName: "value", Value: "6 Taksit" },
        { Id: 686446, PropertyName: "label", Value: "-" },
        { Id: 140851, PropertyName: "value", Value: "2" },
        { Id: 205724, PropertyName: "label", Value: "+" },
        { Id: 243753, PropertyName: "value", Value: "%20 İndirim" },
        { Id: 619795, PropertyName: "value", Value: "Satır Toplamı" },
        { Id: 426899, PropertyName: "value", Value: "₺3.839,84" },
        { Id: 280141, PropertyName: "value", Value: "Not" },
        { Id: 343170, PropertyName: "value", Value: "Müşteri özel istek" },
        { Id: 945047, PropertyName: "label", Value: "Düzenle" },
        { Id: 767694, PropertyName: "value", Value: "Toplam Adet" },
        { Id: 32545, PropertyName: "value", Value: "3 ürün" },
        { Id: 82772, PropertyName: "value", Value: "Ara Toplam" },
        { Id: 82041, PropertyName: "value", Value: "₺6.699,70" },
        { Id: 167763, PropertyName: "value", Value: "İndirim" },
        { Id: 821378, PropertyName: "value", Value: "-₺959,96" },
        { Id: 399419, PropertyName: "value", Value: "Toplam" },
        { Id: 363029, PropertyName: "value", Value: "₺5.739,74" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.ordersummary_987972_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "ordersummary",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("ordersummary", "header2_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("ordersummary", "header2_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
